// Models
PJQ.models.rfq.RFQ = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'rfq',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.rfq.Attachments(model.attachments);
        this.responseAttachments = new PJQ.collections.rfq.Attachments(model.responseAttachments);

        if (model && model.contractedContact) {
            this.contractedContact = new PJQ.models.contacts.Contact(model.contractedContact);
        } else {
            this.contractedContact = null;
        }

        if (model && model.responseBy) {
            this.responseBy = new PJQ.models.contacts.Contact(model.responseBy);
        } else {
            this.responseBy = null;
        }

        this.assignees = new PJQ.collections.contacts.Contacts(model.assignees);

        this.distributeTo = new PJQ.collections.contacts.Contacts(model.distributeTo);

        return model;
    },
    beforeSave: function () {
        this.set({
            assignees: this.assignees.toJSON(),
            contractedContactId: this.contractedContact?.get('id'),
            contractedContact: this.contractedContact ? this.contractedContact.toJSON() : null,
            attachments: this.attachments.toJSON(),
            responseAttachments: this.responseAttachments.toJSON()
        });
    },
    sendQuoteRequest: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/send',
            isAPIv2: true,
        }).post().done((response) => {
            this.set(this.parse(response));
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((response) => {
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    respond: function (callback) {
        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/respond',
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            if (typeof callback === 'function') {
                this.set(this.parse(response));
                callback(true);
            }
        }, this)).fail(_.bind(function (response) {
            if (typeof callback === 'function') {
                callback(false);
            }
        }, this));
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                // TODO: QBO Integration URL
                return 'https://app.sandbox.qbo.intuit.com/app/purchaseorder?txnId=' + externalId;
            default:
                return '';
        }
    }
});

PJQ.models.rfq.Attachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

// Collections
PJQ.collections.rfq.RFQs = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [];
        if (this.options.changeRequestId > 0) {
            params.push({
                parameter: 'changeRequestId',
                value: this.options.changeRequestId
            });
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'rfq'
            }
        ], params);
    },
    model: PJQ.models.rfq.RFQ
});

PJQ.collections.rfq.Attachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.rfq.Attachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'rfq',
                value: this.options.rfqId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});